import { motion } from "framer-motion";
import { ArrowUpRight, MapPin, Phone } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const MAP_SRC =
    "https://maps.google.com/maps?q=Sydney%20CBD%2C%20NSW%2C%20Australia&z=4&output=embed&hl=en";

export default function MapSection() {
    return (
        <section id="map" className="map-section">
            <div className="wrap">
                <motion.div
                    className="section-head"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: EASE }}
                >
                    <div>
                        <div className="section-num">LOCATOR</div>
                        <h2>Where we work</h2>
                    </div>
                    <p className="section-desc">
                        Servicing Australia &amp; New Zealand — remote by
                        default, on-site by arrangement. Based in Sydney, we
                        work with clients across every major city on both
                        sides of the Tasman.
                    </p>
                </motion.div>
            </div>

            <div className="map-shell" data-testid="map-shell">
                <iframe
                    title="SoftwareFairGo service area — Australia & New Zealand"
                    src={MAP_SRC}
                    className="map-frame"
                    data-testid="google-map-embed"
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                />
                <motion.div
                    className="map-card"
                    data-testid="map-card"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <div className="map-card-label">
                        <MapPin size={14} strokeWidth={1.5} /> HEAD OFFICE
                    </div>
                    <div className="map-card-title">Sydney CBD, Australia</div>
                    <div className="map-card-line">33.8688° S, 151.2093° E</div>
                    <div className="map-card-line">
                        Servicing AU &amp; NZ — remote by default
                    </div>
                    <a
                        className="map-card-tel"
                        href="tel:+61447862758"
                        data-testid="map-phone-link"
                    >
                        <Phone size={13} strokeWidth={1.5} /> +61 447 862 758
                    </a>
                    <a
                        className="map-card-link"
                        href="https://maps.google.com/?q=Sydney%20CBD%2C%20NSW%2C%20Australia"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="map-open-external"
                    >
                        Open in Google Maps{" "}
                        <ArrowUpRight size={14} strokeWidth={1.5} />
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
